import Head from 'next/head';
import Table from '@/components/Table';

const Page = () => {
  return (
    <>
      <Head>
        <title>Tables</title>
      </Head>

      <Table />
    </>
  );
};

export default Page;
